export default {
  ROLES: {
    ADMIN: "admin",
    MODERATOR: "moderator",
    MANAGER: "manager",
    USER: "user",
    PENDING: "pending",
  },

  REGIONS: ["מלגאי עמותה","תל אביב - יפו", "חיפה", "באר שבע", "שרון", "ירושלים"],

  ACTIVITY_TYPES: [
    {
      value: 1,
      label: "עידוד לשירות משמעותי",
    },
    {
      value: 2,

      label: "אירוע שיא",
    },
    {
      value: 3,
      label: "אירוע עמותה",
    },
    {
      value: 4,
      label: "ליווי קשישים וניצולי שואה",
    },
    {
      value: 5,
      label: "מילואים"
    },
    {
      value: 6,
      label: "אחר",
    },
  ],
};
